import React from 'react';

export default function RelevanceIndicator({ score }) {
  if (score == null || score < 40) return null;

  if (score >= 70) {
    return (
      <span className="inline-flex items-center text-[11px] font-semibold bg-green-100 text-green-700 px-2 py-0.5 rounded-full">
        Strong Match
      </span>
    );
  }

  return (
    <span className="inline-flex items-center text-[11px] font-semibold bg-yellow-100 text-yellow-700 px-2 py-0.5 rounded-full">
      Good Match
    </span>
  );
}
